import React, { useState } from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@material-ui/core";
import { SecondaryButton } from "@prestosports/commons-ui";
import { useEventContext } from "../../../state/events/context";
import { useAppContext } from "../../../state/app/context";

const ResetEvent = () => {
	const [dialogOpen, setDialogOpen] = useState(false);
	const { resetEventData } = useEventContext();
	const { state: appState } = useAppContext();
	const isSubmitting = appState.isSubmitting();

	const handleClose = () => {
		setDialogOpen(false);
	};

	return (
		<>
			<SecondaryButton onClick={() => setDialogOpen(true)} label="Reset Event" />
			<Dialog open={dialogOpen} onClose={handleClose}>
				<DialogTitle>Reset Event</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Are you sure you want to reset this event?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="secondary">
						Cancel
					</Button>
					<Button onClick={resetEventData} disabled={isSubmitting} color="primary">
						Reset
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default ResetEvent;
